"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
// Given an array of event names, fires the callback the first time that
// any of the events are called on the ref'd element.
// After the callback has been called once, it will never be called again
// for the lifetime of the component.
const useFirstEvent = (events, onFirstEvent) => {
    const [wasFired, setWasFired] = react_1.useState(false);
    const [element, setElement] = react_1.useState(null);
    // A callback ref is used instead of a useRef hook so that
    // setElement() can be called when the ref changes.
    // This allows the useEffect cleanup function to be called
    // to remove event listeners for an element that may no longer exist.
    const callbackRef = react_1.useCallback(el => setElement(el), []);
    // If a ref'd element exists, attach listeners for each event.
    // Remove those listeners if the events, callback, or element change.
    react_1.useEffect(() => {
        if (element && !wasFired) {
            let onEvent = () => { }; // required by typescript
            const removeListeners = () => 
            // @ts-ignore despite the truthy conditional, typescript still thinks `element` can be null
            events.forEach(event => element.removeEventListener(event, onEvent));
            onEvent = () => {
                if (!wasFired) {
                    setWasFired(true);
                    onFirstEvent();
                    removeListeners();
                }
            };
            // @ts-ignore despite the truthy conditional, typescript still thinks `element` can be null
            events.forEach(event => element.addEventListener(event, onEvent));
            return removeListeners;
        }
        return () => { }; // required by linter
    }, [element, events, onFirstEvent, wasFired]);
    // Return the callback ref so that it may be set as the `ref` prop on an element.
    return callbackRef;
};
exports.default = useFirstEvent;
